export const siteInfo = {
  name: '禁漫天堂 JMComic',
  tagline: '最受欢迎的漫画阅读平台',
  description: '禁漫天堂 JMComic 是深受用户喜爱的漫画阅读平台，拥有海量高清漫画资源，涵盖热血、恋爱、悬疑、搞笑、奇幻等多种类型，为漫画爱好者提供极致的在线阅读体验。平台界面简洁、加载迅速、更新及时，是您探索漫画世界的首选入口。',
  latestAddress: 'jmcomic2.moe',
  mirrorAddresses: ['jmcomic1.moe', 'jmcomic2.moe', 'jmcomic3.moe'],
  email: 'support@jmcomic-guide.com',
  established: '2018',
  totalUsers: '500万+',
  totalComics: '10万+',
  dailyUpdate: '500+',
};

export const features = [
  {
    id: 'f1',
    icon: 'ri-book-read-line',
    title: '海量漫画资源',
    description: '收录超过10万部高清漫画作品，涵盖日漫、韩漫、国漫等丰富类型，每日持续更新500+部新章节，满足各类读者的阅读需求。',
  },
  {
    id: 'f2',
    icon: 'ri-smartphone-line',
    title: '多端同步阅读',
    description: '支持PC端、手机端、平板端无缝切换，阅读进度自动云同步。无论在家还是外出，随时随地继续您的漫画之旅。',
  },
  {
    id: 'f3',
    icon: 'ri-speed-up-line',
    title: '极速加载体验',
    description: '采用先进的CDN加速和图片压缩技术，确保漫画页面秒开加载。优化阅读器引擎，翻页流畅不卡顿，带来沉浸式阅读体验。',
  },
  {
    id: 'f4',
    icon: 'ri-search-eye-line',
    title: '智能搜索推荐',
    description: '强大的搜索引擎支持按名称、作者、标签精准查找。基于阅读偏好的AI推荐算法，帮您发现更多符合口味的优质漫画。',
  },
  {
    id: 'f5',
    icon: 'ri-download-cloud-2-line',
    title: '离线下载功能',
    description: '支持漫画章节离线下载，无网络环境下也能畅享阅读。智能缓存管理，节省手机存储空间的同时保证阅读品质。',
  },
  {
    id: 'f6',
    icon: 'ri-shield-check-line',
    title: '安全稳定访问',
    description: '提供多个官方镜像站点，确保用户在任何网络环境下都能稳定访问。持续更新域名信息，保障用户访问畅通无阻。',
  },
];

export const steps = [
  {
    step: 1,
    title: '获取最新地址',
    description: '访问本页面获取禁漫天堂 JMComic 最新官方入口地址，或收藏我们的镜像站列表，确保随时找到可用访问链接。',
    icon: 'ri-link',
  },
  {
    step: 2,
    title: '注册账号',
    description: '点击注册按钮，使用邮箱或手机号快速创建账号。填写基本信息后完成邮箱验证，即可激活您的专属漫画账号。',
    icon: 'ri-user-add-line',
  },
  {
    step: 3,
    title: '浏览分类',
    description: '进入首页后可通过分类导航浏览不同类型的漫画，或使用搜索功能直接查找您喜欢的作品，开启阅读之旅。',
    icon: 'ri-layout-grid-line',
  },
  {
    step: 4,
    title: '开始阅读',
    description: '点击心仪漫画进入详情页，选择章节即可开始阅读。支持横屏、竖屏模式切换，享受流畅舒适的阅读体验。',
    icon: 'ri-play-circle-line',
  },
];

export const faqs = [
  {
    id: 'faq1',
    question: '禁漫天堂 JMComic 的最新访问地址是什么？',
    answer: '禁漫天堂 JMComic 最新官方入口地址为 jmcomic2.moe。如遇访问问题，我们也提供多个备用镜像站：jmcomic1.moe、jmcomic3.moe。建议您收藏本页面，我们将持续更新最新可用的访问地址信息，确保您的访问畅通无阻。',
  },
  {
    id: 'faq2',
    question: '如何注册禁漫天堂 JMComic 账号？',
    answer: '进入禁漫天堂官网后，点击右上角的"注册"按钮，填写您的邮箱地址或手机号码，设置登录密码，接收并输入验证码即可完成注册。注册完成后建议完善个人资料，以便获得更精准的漫画推荐服务。整个过程仅需2分钟。',
  },
  {
    id: 'faq3',
    question: '禁漫天堂是否支持漫画下载？',
    answer: '是的，禁漫天堂 JMComic 支持漫画章节离线下载功能。在漫画详情页点击下载按钮即可将章节保存至本地，下载后可在"我的下载"中查看和管理。支持批量下载和智能缓存清理，方便您在没有网络的环境下继续阅读。',
  },
  {
    id: 'faq4',
    question: '禁漫天堂有哪些漫画分类？',
    answer: '禁漫天堂 JMComic 提供丰富的漫画分类体系，主要包括：热血冒险、恋爱校园、悬疑推理、搞笑日常、奇幻魔法、科幻未来、恐怖惊悚、武侠古风、都市职场等多种类型。此外还支持按地区分类（日漫、韩漫、国漫、欧美漫画）和按受众分类，方便用户精准找到喜爱的漫画。',
  },
  {
    id: 'faq5',
    question: '为什么有时无法访问禁漫天堂？',
    answer: '偶尔无法访问通常是由于网络波动或域名变更导致。解决方法：1) 尝试使用本站提供的镜像站地址访问；2) 清除浏览器缓存和DNS缓存后重试；3) 切换网络环境（如从WiFi切换到移动数据）；4) 使用VPN工具。建议关注我们的官方频道获取最新域名更新通知。',
  },
  {
    id: 'faq6',
    question: '禁漫天堂的漫画更新频率如何？',
    answer: '禁漫天堂 JMComic 每日更新超过500部漫画章节，热门连载作品的更新速度通常与日本、韩国等源站同步，一般延迟不超过24小时。平台设有更新日历功能，您可以订阅喜欢的漫画，更新时第一时间收到通知提醒。',
  },
  {
    id: 'faq7',
    question: '禁漫天堂是否免费使用？',
    answer: '禁漫天堂 JMComic 基础阅读功能完全免费，用户注册后即可免费阅读平台内绝大部分漫画内容。平台也提供VIP会员服务，会员可享受无广告阅读、高清画质、提前看更新章节等专属权益，年费会员价格实惠，性价比较高。',
  },
  {
    id: 'faq8',
    question: '如何在手机上使用禁漫天堂？',
    answer: '禁漫天堂 JMComic 采用响应式网页设计，在手机浏览器中直接访问官网地址即可使用，无需单独下载APP。网站会自动适配手机屏幕尺寸，提供流畅的触屏翻页体验。同时支持添加到手机主屏幕功能，实现类似原生APP的使用体验。',
  },
];

export const siteStats = [
  { label: '累计用户', value: '500万+', icon: 'ri-user-heart-line' },
  { label: '漫画资源', value: '10万+', icon: 'ri-book-3-line' },
  { label: '每日更新', value: '500+', icon: 'ri-refresh-line' },
  { label: '运营年限', value: '8年+', icon: 'ri-calendar-check-line' },
];